import {PartialFrameElements} from '../type/PartialFrameElements.interface';

/**
 * 컨텐츠 노출 여부를 설정하는 함수
 *
 * frameElements가 DOM에 붙은 이후에 불러야 의미가 있습니다.
 */
export function applyContentElementVisibility({
  frameElements,
  visible,
}: {
  frameElements: PartialFrameElements;
  visible: boolean;
}) {
  const {contentElement} = frameElements;

  contentElement.style.visibility = visible ? 'visible' : 'invisible';
}
